import React from 'react';

const LogoComponent = () => {
  return <div className="top-logo"> </div>;
};

export default LogoComponent;
